import { render } from "./myPlan.vue?vue&type=template&id=77d50863"
import script from "./myPlan.vue?vue&type=script&lang=js"
export * from "./myPlan.vue?vue&type=script&lang=js"

import "./myPlan.vue?vue&type=style&index=0&id=77d50863&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__